import PropTypes from 'prop-types';
import { useContext } from 'react';
import classnames from 'classnames';
import { HeaderFooterServerVarsContext } from '../HeaderFooterServerVarsContext/HeaderFooterServerVarsContext.tsx';

import dibsCss from 'dibs-css';
import styles from './SearchBarSection.scss';

export const SearchBarSection = ({ title, children }) => {
    const { isMobile, isSearchBarRedesignVariant } = useContext(HeaderFooterServerVarsContext);
    return (
        <div
            data-tn="search-bar-section"
            className={
                isSearchBarRedesignVariant
                    ? classnames(
                          dibsCss.flex,
                          dibsCss.flexCol,
                          isMobile ? dibsCss.gapSmaller : dibsCss.gapXxsmall
                      )
                    : styles.section
            }
        >
            <div
                data-tn="search-bar-header"
                className={
                    isSearchBarRedesignVariant
                        ? classnames(
                              dibsCss.textSubHeaderSmallHeavy,
                              dibsCss.textSatan,
                              dibsCss.mxSmall,
                              dibsCss.borderBSolid,
                              dibsCss.borderB,
                              dibsCss.borderDolphin,
                              isMobile
                                  ? [dibsCss.mtLarge, dibsCss.pbXsmall]
                                  : [dibsCss.mtSmall, dibsCss.pbXxsmall]
                          )
                        : styles.header
                }
            >
                {title}
            </div>
            {children}
        </div>
    );
};

SearchBarSection.propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
};
